import { render, staticRenderFns } from "./FiscalApiTokens.vue?vue&type=template&id=0b52a946&scoped=true"
import script from "./FiscalApiTokens.vue?vue&type=script&lang=js"
export * from "./FiscalApiTokens.vue?vue&type=script&lang=js"
import style0 from "./FiscalApiTokens.vue?vue&type=style&index=0&id=0b52a946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52a946",
  null
  
)

export default component.exports